import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef, ViewChild } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { environment } from 'environments/environment';
import { TranslateService } from '@ngx-translate/core';
import {
  ValidationUtilService,
  ApiRequestService,
  LookupDataService,
  CommonUtilty,
  I18nService,
  MultiLingualService,
  InteractService,
} from 'app'
import { ClientSearchComponent } from '../client-search/client-search.component'
import { PolicySearchComponent } from '../policy-search/policy-search.component'
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import * as moment from 'moment/moment';

@Component({
  selector: 'app-generic-search',
  templateUrl: './generic-search.component.html',
  styleUrls: ['./generic-search.component.scss']
})
export class GenericSearchComponent implements OnInit {

  constructor(private viewContainerRef: ViewContainerRef,
    private validationUtilService: ValidationUtilService,
    private apiRequestService: ApiRequestService,
    private fb: FormBuilder,
    private commonUtilty: CommonUtilty,
    private i18nService: I18nService,
    private multiLingualService: MultiLingualService,
    private translateService: TranslateService,
    private lookupDataService: LookupDataService,
    private interactService: InteractService) { }

  //Declaraions which might need developer input
  claimsBasicDetailsForm: FormGroup
  CLAIMSBASICDETAILSFORMNAME = "claimsBasicDetailsForm"
  lookupsToBind = ['clmEventTypeCd', 'clmCauseOfDeathCd']
  currentSearchPanel: any
  custSearchFor: any
  allowedSearchModes = {
    customerSearchOnly: 'customerSearchOnly',
    customerSearchOrCapture: 'customerSearchOrCapture',
    policySearchOnlyBasedOnPolicyData: 'policySearchOnlyBasedOnPolicyData',
    policySearchOnlyBasedOnClientData: 'policySearchOnlyBasedOnClientData',
    policySearchOnlyBasedOnClientOrPolicyData: 'policySearchOnlyBasedOnClientOrPolicyData'
  }

  allowedSearchPanels = {
    client: 'CLIENT',
    captureClient: 'CAPTURECLIENT',
    policy: 'POLICY'
  }

  allowedOutputTypes = {
    client: 'CLIENT',
    policy: 'POLICY'
  }

  allowedRoleTypes = {
    NOMINEE: 'Nominee',
    CLAIMANT: 'Claimant',
    OWNER: 'Policy Holder',
    PAYER: 'Payer',
    INSURED: 'Insured',
    PRIMARYINSURED: 'Primary Insured',
    AGENT: 'Agent'
  }

  /**
   * ComponentSpecific Inputs, Outputs and Functions
   *  
   */
  @Output() componentOutput = new EventEmitter<any>();
  @Output() enableFooter = new EventEmitter<any>();
  @Output() changedField = new EventEmitter<any>();
  @Input() type: string;
  @Input() modalFlag: any;
  startSearchPanel: string

  _captureRole: string;
  _captureRoleKey: string
  @Input()
  set captureRole(role: string) {
    console.log("capture role in generic search", role);
    this._captureRoleKey = role
    if (this.allowedRoleTypes[role] === null) throw "Invalid Role Recieved"
    else
      this._captureRole = this.allowedRoleTypes[role];

  }
  get captureRole() { return this._captureRole; }
  _searchMode: string;
  @Input()
  set searchMode(mode: string) {
    this._searchMode = mode
    if (this._searchMode === this.allowedSearchModes.policySearchOnlyBasedOnClientOrPolicyData) {
      this.custSearchFor = this.allowedOutputTypes.policy
      this.startSearchPanel = this.allowedSearchPanels.client
    }
    else if (this._searchMode === this.allowedSearchModes.customerSearchOnly) {
      this.custSearchFor = this.allowedOutputTypes.client
      this.startSearchPanel = this.allowedSearchPanels.client
    }
    else if (this._searchMode === this.allowedSearchModes.customerSearchOrCapture) {
      this.custSearchFor = this.allowedOutputTypes.client
      //this.startSearchPanel = this.allowedSearchPanels.client
      this.startSearchPanel = this.allowedSearchPanels.captureClient
    }
    else if (this._searchMode === this.allowedSearchModes.policySearchOnlyBasedOnClientData) {
      this.custSearchFor = this.allowedOutputTypes.policy
      //this.startSearchPanel = this.allowedSearchPanels.client
      this.startSearchPanel = this.allowedSearchPanels.captureClient

    }
    else if (this._searchMode === this.allowedSearchModes.policySearchOnlyBasedOnPolicyData) {
      this.custSearchFor = null
      this.startSearchPanel = this.allowedSearchPanels.policy
    }
    else {
      throw "Invalid Search Mode Added to <app-generic-search></app-generic-search> in " + this.getParentComponentName();

    }
  }
  get searchMode() { return this._searchMode; }


  private _inputDataForEdit = null;
  @Input()
  set inputDataForEdit(value: any) {
    if (value) this._inputDataForEdit = value;
    this.segrigateClientData(this._inputDataForEdit);
  };

  @ViewChild('clientSearch') clientSearch: ClientSearchComponent;
  @ViewChild('policySearch') policySearch: PolicySearchComponent;

  EmitComponentOutput(data) {
    this.componentOutput.emit(data)
    console.log("generic search emiited data to transaction component", data);
  }
  EmitChangedField(data){
    this.changedField.emit(data);
  }
  getParentComponent(): Component {
    try{ return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component
 } catch{}
  }
  getParentComponentName(): Component {
    try{ return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name
 } catch{}
  }

  fetchOutputFromChild(e) {
    this.EmitComponentOutput(e)
  }

  fetchOutputFromAgentChild(e) {
    this.EmitComponentOutput(e)
  }

  ngOnInit() {
    var consoleStyle = 'color: red; padding: 2px 5px; border-radius: 2px'
    if (environment && !environment.production) {
      console.group('%cClaims Basic Details : Usage detected on ' + this.getParentComponentName(), 'color: white; background-color: orange; padding: 2px 5px; border-radius: 2px');
      console.log("%c<app-claims-basic-details></app-claims-basic-details>, has been used. ", consoleStyle)
      console.log("%cYou can override default title, message and icon(ng-zorro icon name).", consoleStyle)
      console.log("%cExample , <app-claims-basic-details (componentOutput)='doSomethingOnDataReceived()'></app-claims-basic-details>", consoleStyle)
      console.groupEnd();
    }
    this.currentSearchPanel = this.startSearchPanel
    console.log("current search panel", this.currentSearchPanel);
  }

  /* Search by Customer or Policy Meta Data from UI Design */
  searchCustOrPolicyLoading: boolean = false;
  animateLoad() {
    this.searchCustOrPolicyLoading = true;
    this.showCustomerPolicies = false;
    setTimeout(() => { this.searchCustOrPolicyLoading = false }, 1200);
    if (this.currentSearchPanel === 'CAPTURECLIENT') {
      this.enableFooter.emit(true)
    }
    else {
      this.enableFooter.emit(null)
    }
  }
  showCustomerPolicies: boolean = false;
  dummyClientDO =
    {
      "parentObject": null,
      "versionId": 2,
      "guid": "BCE686E8-BC34-47CC-8F2E-CCFF46F68A9C",
      "createdDt": 1559546247523,
      "updatedDt": 1560322637205,
      "createdUser": "AdminScript",
      "updatedUser": "INT1",
      "caseManager": null,
      "fieldKey": null,
      "fieldValue": null,
      "id": 2,
      "externalClientNum": null,
      "clientTypeCd": "PERSON",
      "clientNum": "C00071",
      "deDupStatusCd": null,
      "statusCd": null,
      "duplicateFl": null,
      "blackListedFl": null,
      "blackListedReasonCd": null,
      "duplicateClientNum": null,
      "fromEffectiveDT": null,
      "lastEffectiveDt": null,
      "organisationDO": null,
      "personDO": {
        "parentObject": null,
        "versionId": 1,
        "guid": "f8ed86bd-ff07-45f7-b104-e85f5e28e695",
        "createdDt": 1559546247546,
        "updatedDt": 1560322637206,
        "createdUser": "AdminScript",
        "updatedUser": "INT1",
        "caseManager": null,
        "id": 2,
        "titleCd": 'MR',
        "firstName": "Jill",
        "middleName": null,
        "lastName": "Smith",
        "firstName1": null,
        "middleName1": null,
        "lastName1": null,
        "genderCd": "FEMALE",
        "dateOfBirth": [1990, 7, 2],
        "age": null,
        "maritalStatusCd": null,
        "mothersMaidenName": null,
        "fathersName": null,
        "givenName": null,
        "legalName": null,
        "otherName": null,
        "countryOfBirthCd": null,
        "citizenshipCd": null,
        "politicalFlag": null,
        "convictedFlag": null,
        "sourceOfIncomeCd": null,
        "fromEffectiveDT": null,
        "lastEffectiveDt": null,
        "personEmploymentList": [],
        "personIdentityList": [],
        "objectName": "PersonDO",
        "name": "Jill Smith"
      },
      "clientAddressList": [
        {
          "parentObject": null,
          "versionId": 1,
          "guid": "80638f36-78d1-488e-bdcb-b1b22e84a2ec",
          "createdDt": 1559546247596,
          "updatedDt": 1560322637207,
          "createdUser": "AdminScript",
          "updatedUser": "INT1",
          "caseManager": null,
          "id": 2,
          "clientAddressID": null,
          "typeCd": "RESIDENCE",
          "subTypeCd": null,
          "addressLine1": "House 101",
          "addressLine2": "Sussex St",
          "addressLine3": null,
          "addressLine4": null,
          "cityCd": "PUNE",
          "talukaCd": null,
          "villageCd": null,
          "stateCd": "MAHARASHTRA",
          "countryCd": "INDIA",
          "postCode": 412307,
          "prefferedFl": true,
          "fromEffectiveDT": null,
          "lastEffectiveDt": null,
          "objectName": "ClientAddressDO"
        },
        {
          "parentObject": null,
          "versionId": 1,
          "guid": "5f70a86e-3cef-44a0-9ca1-91ed9c209c9b",
          "createdDt": 1559546247653,
          "updatedDt": 1560322637208,
          "createdUser": "AdminScript",
          "updatedUser": "INT1",
          "caseManager": null,
          "id": 13,
          "clientAddressID": null,
          "typeCd": "MAILING",
          "subTypeCd": null,
          "addressLine1": "House 701",
          "addressLine2": "Sussex St",
          "addressLine3": null,
          "addressLine4": null,
          "cityCd": "AHMEDNAGAR",
          "talukaCd": null,
          "villageCd": null,
          "stateCd": "MAHARASHTRA",
          "countryCd": "INDIA",
          "postCode": 413701,
          "prefferedFl": false,
          "fromEffectiveDT": null,
          "lastEffectiveDt": null,
          "objectName": "ClientAddressDO"
        }
      ],
      "clientContactDetailsList": [
        {
          "parentObject": null,
          "versionId": 1,
          "guid": "17258d35-3947-4faf-bfbe-5526ad16136d",
          "createdDt": 1559546247806,
          "updatedDt": 1560322637207,
          "createdUser": "AdminScript",
          "updatedUser": "INT1",
          "caseManager": null,
          "id": 2,
          "typeCd": "BUSINESS",
          "subTypeCd": null,
          "contactNum": "'112233000071",
          "extensionNum": null,
          "prefferedFl": true,
          "fromEffectiveDT": null,
          "lastEffectiveDt": null,
          "isd": null,
          "std": null,
          "objectName": "ClientPhoneDO"
        },
        {
          "parentObject": null,
          "versionId": 1,
          "guid": "8c8fb47e-4dc0-4e9a-bbea-8bc50b94a2fe",
          "createdDt": 1559546247856,
          "updatedDt": 1560322637207,
          "createdUser": "AdminScript",
          "updatedUser": "INT1",
          "caseManager": null,
          "id": 13,
          "typeCd": "HOME",
          "subTypeCd": null,
          "contactNum": "'992233000071",
          "extensionNum": null,
          "prefferedFl": false,
          "fromEffectiveDT": null,
          "lastEffectiveDt": null,
          "isd": null,
          "std": null,
          "objectName": "ClientPhoneDO"
        }
      ],
      "clientEmailList": [
        {
          "parentObject": null,
          "versionId": 1,
          "guid": "6649176e-6348-42e3-9901-943d9ec00489",
          "createdDt": 1559546247710,
          "updatedDt": 1560322637206,
          "createdUser": "AdminScript",
          "updatedUser": "INT1",
          "caseManager": null,
          "id": 2,
          "typeCd": "BUSINESS",
          "emailId": "Jill_Smith@testmail.com",
          "prefferedFl": true,
          "fromEffectiveDT": null,
          "lastEffectiveDt": null,
          "objectName": "ClientEmailDO"
        },
        {
          "parentObject": null,
          "versionId": 1,
          "guid": "14a6cdbe-fce1-4380-b96e-e06ecd76deec",
          "createdDt": 1559546247756,
          "updatedDt": 1560322637206,
          "createdUser": "AdminScript",
          "updatedUser": "INT1",
          "caseManager": null,
          "id": 13,
          "typeCd": "PERSONAL",
          "emailId": "Jill_Smith_1@testmail.com",
          "prefferedFl": false,
          "fromEffectiveDT": null,
          "lastEffectiveDt": null,
          "objectName": "ClientEmailDO"
        }
      ],
      "clientAdditionalFieldDOs": [],
      "clientRelationshipDOs": [],
      "preferredEmail": "Jill_Smith@testmail.com",
      "preferredMobileNum": null,
      "objectName": "ClientDO",
      "name": "Jill Smith"
    }


  // 
  editableClient: any = null;
  segrigateClientData(client) {
    this.editableClient = client;
  }
  getChangeField(fieldKey){
    this.changedField.emit(fieldKey)
  }
}
